/**
 * The purchase steps that paint the pre-checkout estimate. Checkout, the complete page, the
 * review and quick checkout render the charged breakdown instead.
 * @type {string[]}
 */
// eslint-disable-next-line import/prefer-default-export
export const PRE_CHECKOUT_STEPS = ['dSeats', 'rSeats', 'passengers'];
